import React, { useRef, useState } from 'react';
import {
    User,
    LogOut,
} from "lucide-react";
import { AvatarImage, CenteredModal, LargeModal, AvatarCharecter } from 'components';
import { useAuth, useClickOutside, useMember, useUser } from 'hooks';
import { repareURL } from 'utils';
import Profile from './Profile';
import SnackbarUtils from 'utils/SnackbarUtils';

export default function UserDropdown() {
    const profile = useUser(state => state.profile);
    const { setProfile } = useUser();
    const { updateMember } = useMember()
    const { onLogout } = useAuth();
    const [isShow, setIsShow] = useState(false)
    const [action, setAction] = useState('');
    const dropdownRef = useRef<HTMLDivElement>(null);

    useClickOutside(dropdownRef, () => setIsShow(false));

    const handleAction = (act) => () => {
        setIsShow(false)
        switch (act) {
            case 'logout':
            case 'updateProfile':
                setAction(act);
                break;

            default:
                break;
        }
    }

    const handleUpdateProfile = (payload) => {
        updateMember.mutate(payload, {
            onSuccess: res => {
                onClose();
                if (res.statusCode === 200) {
                    setProfile(res.data);
                    SnackbarUtils.success(res?.message);
                    return;
                }
                SnackbarUtils.error(res?.message ?? "Cập nhật tài khoản lỗi!");
                return;
            }
        })
    }

    const onClose = () => {
        setAction('')
    }

    return (
        <div className="relative inline-block text-left">
            <div onClick={() => setIsShow(!isShow)} className="flex items-center space-x-3 px-4 py-2 cursor-pointer">
                {profile.avatar ? <img src={repareURL(profile.avatar)} alt={profile?.name} className="w-8 h-8 rounded-full" /> : <AvatarCharecter className="w-8 h-8" name={profile?.name} />}
                <div className="leading-tight">
                    <div className=" text-[#1e40af] text-base font-bold">{profile?.name ?? ''}</div>
                </div>
            </div>
            {action === 'logout' && <CenteredModal onClose={onClose} onConfirm={onLogout} />}
            {action === 'updateProfile' &&
                <LargeModal
                    title={' Cập nhật tài khoản'}
                    onClose={onClose}>
                    <Profile onClose={onClose} item={profile} onConfirm={({ root }) => handleUpdateProfile(root)} />
                </LargeModal>}
            <div ref={dropdownRef} className={`${!isShow ? 'hidden' : ''} absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50`}>
                <ul className="py-1">
                    <li onClick={handleAction('updateProfile')} className="flex items-center px-4 py-2 hover:bg-gray-50 cursor-pointer text-sm text-gray-700">
                        <User className="w-4 h-4 mr-2" /> Cập nhật tài khoản
                    </li>
                    {/* <li className="flex items-center px-4 py-2 hover:bg-gray-50 cursor-pointer text-sm text-gray-700">
                        <Settings className="w-4 h-4 mr-2" /> Settings
                    </li> */}
                    {/* <li className="flex items-center px-4 py-2 hover:bg-gray-50 cursor-pointer text-sm text-gray-700">
                        <LockKeyhole className="w-4 h-4 mr-2" /> Đổi mật khẩu
                    </li> */}
                    <li onClick={handleAction('logout')} className="flex items-center px-4 py-2 hover:bg-gray-50 cursor-pointer text-sm text-gray-700">
                        <LogOut className="w-4 h-4 mr-2" /> Đăng xuất
                    </li>
                </ul>
            </div>
        </div>
    );
}
